<template>
    <div class="proposal-table px-3">
        <b-table-simple responsive bordered class="table-sm">
            <b-thead>
                <b-tr>
                    <b-th class="align-middle text-center">No.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 150px;">Merchant<br> Summary</b-th>
                    <b-th class="align-middle text-center" style="min-width: 100px;">Card Expiry</b-th>
                    <b-th class="align-middle text-center" style="min-width: 110px;">Limit</b-th>
                    <b-th class="align-middle text-center" style="min-width: 110px;">Outstanding</b-th>
                    <b-th class="align-middle text-center" style="min-width: 110px;">Merchant<br> Sett.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 110px;">Available<br> Limit</b-th>
                    <b-th class="align-middle text-center" style="min-width: 130px;">Swipe<br> Bck Amt.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 100px;">Charge<br>(%)</b-th>
                    <b-th class="align-middle text-center" style="min-width: 110px;">Refund</b-th>
                    <b-th class="align-middle text-center" style="min-width: 110px;">TopUp</b-th>
                    <b-th class="align-middle text-center" style="min-width: 120px;">Sett. Date</b-th>
                    <b-th class="align-middle text-center" style="min-width: 120px;">Swipe<br> Bck Date</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in tableData" :key="index" class="text-center">
                    <b-td class="align-middle">{{ index + 1 }}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_loan_statue  }} ({{ item.pcom_bank_code || 'N/A' }})</b-td>
                    <b-td class="align-middle input-cell">
                        <el-date-picker
                            :disabled="!is_editable"
                            v-model="item.pcom_card_expiry"
                            type="month"
                            value-format="yyyy-MM-DD"
                            format="MMM yyyy"
                            prefix-icon="none"
                            clear-icon="none"
                            placeholder="Pick a day"
														size="mini"
														>
                        </el-date-picker>
                    </b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_credit_limit | moneyFormatter}}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_current_outstanding | moneyFormatter }}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_merchant_solution | moneyFormatter }}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_available_limit | moneyFormatter}}</b-td>
                    <b-td class="align-middle input-cell">
                        <b-form-input type="text" v-model="item.pcom_swipe_back_amount" @keydown="_gHlp.checkNonNumericInput"  :disabled="!is_editable" size="mini"></b-form-input>
                    </b-td>
                    <b-td class="align-middle input-cell">
                        <b-form-input type="text" v-model="item.pcom_charge" @keydown="_gHlp.checkNonNumericInput"  :disabled="!is_editable" size="mini"></b-form-input>
                    </b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_refound | moneyFormatter }}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_topup_cashout | moneyFormatter }}</b-td>
                    <b-td class="align-middle input-cell">
										    <el-date-picker
                            v-model="item.pcom_settlement_date"
                            :disabled="!is_editable"
                            type="date"
                            value-format="yyyy-MM-dd"
                            format="d MMM yyyy"
                            prefix-icon="none"
                            clear-icon="none"
                            placeholder="Pick a day"
														size="mini">
                        </el-date-picker>
                    </b-td>
                    <b-td class="align-middle input-cell">
                        <el-date-picker
                            v-model="item.pcom_swipe_back_date"
                            :disabled="!is_editable"
                            type="date"
                            value-format="yyyy-MM-dd"
                            format="d MMM yyyy"
                            prefix-icon="none"
                            clear-icon="none"
                            placeholder="Pick a day"
														size="mini">
                        </el-date-picker>
                    </b-td>
                </b-tr>
            </b-tbody>
            <b-tfoot>
                <b-tr class="font-weight-600">
                    <b-td colspan="3" class="text-right">
                        <p class="font-weight-600">Total</p>
                    </b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, merchant) => acc + (isNaN(parseFloat(merchant.pcom_credit_limit)) ? 0 : parseFloat(merchant.pcom_credit_limit)), 0) | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, merchant) => acc + (isNaN(parseFloat(merchant.pcom_current_outstanding)) ? 0 : parseFloat(merchant.pcom_current_outstanding)), 0) | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, merchant) => acc + (isNaN(parseFloat(merchant.pcom_merchant_solution)) ? 0 : parseFloat(merchant.pcom_merchant_solution)), 0) | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, merchant) => acc + (isNaN(parseFloat(merchant.pcom_available_limit)) ? 0 : parseFloat(merchant.pcom_available_limit)), 0) | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center" >{{ tableData.reduce((acc, merchant) => acc + (isNaN(parseFloat(merchant.pcom_swipe_back_amount)) ? 0 : parseFloat(merchant.pcom_swipe_back_amount)), 0) | moneyFormatter }}</b-td>
										<b-td></b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, merchant) => acc + (isNaN(parseFloat(merchant.pcom_refound)) ? 0 : parseFloat(merchant.pcom_refound)), 0) | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, merchant) => acc + (isNaN(parseFloat(merchant.pcom_topup_cashout)) ? 0 : parseFloat(merchant.pcom_topup_cashout)), 0) | moneyFormatter }}</b-td>
										<b-td></b-td>
										<b-td></b-td>
                </b-tr>
            </b-tfoot>
        </b-table-simple>
        <div class="text-right" v-if="is_editable">
            <el-button size="mini" type="primary" icon="fa fa-save" @click="update" :loading="is_loading"> Update</el-button>
        </div>
    </div>
</template>
<script>
import { Select, Option, DatePicker, Button } from 'element-ui'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import {isEqual, cloneDeep} from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
		props: ['psal_id','psal_invinity_id','is_editable'],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [Button.name]: Button,
    },
    data() {
        return {
            tableData: [],
            originalTableData: [],
            is_loading: false,
            is_updated:false,
        }
    },
    watch:{
			psal_id: {
				handler(newVal) {
					if(!_gHlp.isEmpty(newVal)){
						this.getListing(newVal)
					}
				},
				immediate: true,
			}
    },
    methods: {
				...mapActions(useInvinityStore, ['syncToLms']),
				...mapActions(useInitialProposalStore, ['updateProposalCommitment','getProposalCommitmentList']),
				getListing(psal_id){
					this.tableData = []
					this.originalTableData = []
					let params = {
						search:{
							pcom_psal_id: psal_id,
							pcom_kind: 'merchant'
						},
						paginate:'no_paginate'
					}
					this.getProposalCommitmentList(params).then(resp => {
						this.tableData = _gHlp.getValue(resp,'data',[]);
						this.originalTableData = cloneDeep(this.tableData);
					}).catch(e => {
						_gNotif.errorFunction(e)
					})
				},
        update(){
					var axiosCalls = []
					this.is_loading = true

					this.tableData.forEach((item) => {
							const original_item = this.originalTableData.find(o_item => o_item.pcom_id === item.pcom_id)
							if(original_item && !isEqual(original_item, item)){
								axiosCalls.push(this.updateProposalCommitment(item,item.pcom_id))
							}
					})

					Promise.all(axiosCalls)
							.then(res  => {
									_gNotif.notifySuccess('<b>Merchant Settlements</b> - Successfully Updated.')
									this.is_loading = false
									if(axiosCalls.length > 0){
											initialProposalEventBus.$emit('refresh-proposal-detail')
											if(!_gHlp.isEmpty(this.psal_invinity_id)){
												this.syncToLms(this.psal_id)
											}
									}
							})
							.catch(e => {
									this.is_loading = false
									_gNotif.errorFunction(e)
							})
        }
    }
}
</script>